import { Fragment } from "react";
import { Outlet } from "react-router-dom";
import MuiNavbar from "components/layout/MuiNavbar";
import LabelBottomNavigation from "components/layout/MuiNavbar/BottomBar";
import { Box } from "@mui/material";
import Footer from "./Footer";
import { fillParent, footerFlex, scrollingBox } from "utils/base-styles";

export default function Layout() {
  return (
    <Fragment>
      <Box
        sx={{
          display: { xs: "block", sm: "grid" },
          gridTemplateAreas: "'head' 'content'",
          gridTemplateRows: "auto 1fr",
          gridTemplateColumns: "1fr",
          height: { xs: "100%", sm: "100vh" },
          width: "100vw",
          overflow: "hidden",
        }}
      >
        <Box sx={{ gridArea: "head" }}>
          <MuiNavbar />
        </Box>
        <Box
          sx={{
            position: "relative",
            gridArea: "content",
          }}
        >
          <Box
            className="search-layout"
            // ref={ref}
            sx={{
              ...fillParent,
              ...scrollingBox,
              ...footerFlex,
            }}
          >
            <Box>
              <Outlet />
            </Box>
            <Footer />
          </Box>
        </Box>
      </Box>
      <LabelBottomNavigation />
    </Fragment>
  );
}
